import { z } from 'zod';
import { eventType, EventBaseSchema } from '@eigtech/event-stream-types';
export const serviceName = 'meetings';
export const serviceEventType = (entity, eventName) => eventType(serviceName, entity, eventName);
export const MeetingsServiceEventBaseSchema = EventBaseSchema.merge(z.object({
    type: serviceEventType(),
}));
